import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import { IPhotoOrderListItem } from '../Entities';
import { Table } from 'react-bootstrap';
import PhotoOrderListRow from './PhotoOrderListRow';

interface IPhotoOrderListProps {
    items: IPhotoOrderListItem[];
    user: any;
}

const PhotoOrderList = (props: IPhotoOrderListProps) => {
    return (
        <Table className="order-table table-nopadding col-md-12" hover responsive data-testid="order-table">
            <thead>
                <tr>
                    <th>{Translate('orders/list/photo/header/order-number')}</th>
                    <th>{Translate('orders/list/photo/header/broker-firm')}</th>
                    <th>{Translate('orders/list/photo/header/package-product')}</th>
                    <th>{Translate('orders/list/photo/header/photographer-name')}</th>
                    <th>{Translate('orders/list/photo/header/order-status')}</th>
                    <th>{Translate('orders/list/photo/header/number-of-images')}</th>
                    <th>{Translate('orders/list/photo/header/deadline')}</th>
                    <th>{Translate('orders/list/photo/header/performed-at')}</th>
                    <th>{Translate('orders/list/photo/header/order-locked-by')}</th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.items &&
                    props.items.map((i: IPhotoOrderListItem) => (
                        <PhotoOrderListRow order={i} key={i.orderId} user={props.user} />
                    ))}
            </tbody>
        </Table>
    );
};

export default PhotoOrderList;
